module.exports = __webpack_public_path__ + "static/10week-ccaad0440b2840cc94fd636cc4123904.png";